<template>
 <el-container class="flex flex-row w-full h-full">
  <el-header class="flex flex-row h-[80px] bg-[#F3F5F7]">
    <div class="bg-no-repeat w-[100px] h-[34px] ml-4 mt-3 bg-cover bg-no-repeat cursor-pointer" style="background-image:url(/images/bst.png);background-size:contain" @click="goHome">
    </div>
    <div class="flex-1"></div>
    <div class="flex flex-row items-center">
      <img src="/images/language.png" class="w-[16px] h-[16px] mr-[10px]"/>
      <span class="text-center text-sm leading-[60px] pr-[20px] text-[#6d6d6d]">简体中文</span>
    </div>
  </el-header>

  <el-main class="w-full h-full bg-[#fafafa]">
    <div class="flex flex-row h-full">
      <div class="flex-1 hidden md:block">
        <div class="flex flex-row justify-center h-full">
          <div class="flex flex-col justify-center w-[420px] ">
              <div class="text-center text-2xl mb-[20px]" >安全可靠的区块链合同</div>
              <div class="text-center text-base mb-[20px] text-[#7a7a93]">
                <p class="p-0.5">在线签署，安全高效</p>
                <p class="p-0.5">电子印章随身带，随时随地签署</p>
              </div>
              <div class="text-right px-[30px] mt-[50px]">
                <img src="/images/main-bg.png" class="w-[420px]"/>
              </div>
          </div>
        </div>
      </div>

      <div class="flex-1 flex flex-col justify-center">
          <div class="flex flex-row items-center md:justify-start justify-center">
            <el-tabs v-model="activeTab" class="px-[30px] py-[20px] login-tab bg-white w-[420px]">
              <el-tab-pane label="密码登录" name="password" class="text-center">
                <el-input v-model="mobile" placeholder="请输入手机号" class="pt-[20px] pb-[10px]"></el-input>
                <el-input show-password v-model="password" placeholder="请输入密码" class="pt-[10px] pb-[10px]"></el-input>
                
                <el-checkbox v-model="agree" class="mt-[10px]">我已阅读并同意<a href="#" class="text-[#4f94f7]">《服务协议》</a><a href="#" class="text-[#4f94f7]">《隐私政策》</a></el-checkbox>
                
                <el-button type="success" @click="handleLoginWithPassword()" class="w-full !mt-[15px]">登录</el-button>

                <div class="flex flex-row text-sm pt-[20px]">
                  <div class="flex-1 flex-start text-left"><a href="/register" class="text-[#4f94f7]">新用户注册</a></div>
                  <div class="flex-1 flex-end text-right"><a href="/modifypwd" class="text-[#4f94f7]">找回或更改密码</a></div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="验证码登录" name="verifyCode" class="text-center">
                <el-input v-model="mobile" placeholder="请输入手机号" class="pt-[20px] pb-[10px]"></el-input>
                <el-input v-model="verifyCode" maxlength="4" placeholder="请输入动态验证码" class="pt-[10px] pb-[10px]"><el-button slot="append" style="font-weight:normal;color:#4f94f7" @click="handleGetVerifyCode()">获取验证码</el-button>
                </el-input>
               
                <el-checkbox v-model="agree" class="mt-[10px]">我已阅读并同意<a href="#" class="text-[#4f94f7]">《服务协议》</a><a href="#" class="text-[#4f94f7]">《隐私政策》</a></el-checkbox>

                <el-button type="success" @click="handleLoginWithVerifyCode()" class="w-full !mt-[15px]">登录</el-button>

                <div class="flex flex-row text-sm pt-[20px]">
                  <div class="flex-1 flex-start text-left"><a href="/register" class="text-[#4f94f7]">新用户注册</a></div>
                  <div class="flex-1 flex-end text-right"><a href="/modifypwd" class="text-[#4f94f7]">找回或更改密码</a></div>
                </div>
              </el-tab-pane>
                           
              <!-- <el-tab-pane label="扫码登录" name="qrcode" class="text-center">
                <div class="text-center">
                  <img src="/images/qrcode.png" class="h-[210px] mx-auto" />
                </div>

                <p class="text-sm py-3">请使用微信扫描二维码登录</p>

                <el-checkbox v-model="agree">我已阅读并同意<a href="#" class="text-[#4f94f7]">《服务协议》</a><a href="#" class="text-[#4f94f7]">《隐私政策》</a></el-checkbox>

                <p class="text-sm py-3">没有账号？<a href="/register" class="text-[#4f94f7]">立即注册</a></p>
              </el-tab-pane> -->
            </el-tabs>
          </div>
      </div>
    </div>
  </el-main>

  <el-footer class="h-[45px] bg-[#F3F5F7]">
    <div class="flex justify-center items-center">
      <div class="leading-[45px] pr-[20px] mr-[20px] text-xs text-[#6d6d6d]">Copyright @2025 南京百市通数字科技有限公司</div>
      <div class="leading-[45px] pr-[20px] mr-[10px] text-xs text-[#6d6d6d] sm:block hidden"><a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备18043487号-6</a></div>
    </div>
  </el-footer>
</el-container>
</template>

<script>
import { 
  loginWithPassword,
  loginWithVerifyCode,
  getVerifyCode
} 
from '@/api/api';

import {
  ErrorVerifyCode,
  ErrorLoginAccount,
  ErrorLoginPassword
} from '@/api/consts';

export default {
  name: 'LoginPage',
  data(){
    return {
      activeTab: "password",
      hideControl: false,
      mobile: "",
      password: "",
      verifyCode: "",
      agree:true,
    }
  },
  methods: {
    handleGetVerifyCode() {
      if (!this.testMobile()) {
        return
      }
      
      const raw = JSON.stringify({
        "mobile": this.mobile
      });
      getVerifyCode(raw).then(() => {
        this.$message.info("请求已发送，请稍候...");
      })
      .catch(error => {
        console.error("错误信息：", error);
      });
    },

    async handleLoginWithPassword() {
      if (!this.testMobile() || !this.testPassword() || !this.testAgreement()) {
        return
      }

      const raw = JSON.stringify({
        "account": this.mobile, 
        "password" : this.password
      });

      try {
        let result = await loginWithPassword(raw);
        let data = result.data;
        if (data.code === 0) {
          localStorage.setItem('uid', data.data.uid);
          localStorage.setItem('token', data.data.token);
          localStorage.setItem('psnId', data.data.psnId);
          localStorage.setItem('uname', data.data.uname);
          this.$router.push('/home');
        } else if (data.code == ErrorLoginAccount){
          this.$message.error("输入的账号不存在");
        } else if (data.code == ErrorLoginPassword){
          this.$message.error("输入的密码不正确");
        } else {
          this.$message.error("输入的账号或者密码不正确");
        }
      } catch(e) {
        console.error("错误信息：", e);
        this.$message.error("无法登录系统");
      }
    },

    async handleLoginWithVerifyCode() {
      if (!this.testMobile() || !this.testCode() || !this.testAgreement()) {
        return
      }

      const raw = JSON.stringify({
        "mobile": this.mobile,
        "code": this.verifyCode,
      });

      try {
        let result = await loginWithVerifyCode(raw);
        let data = result.data;
        if (data.code == 0) {
            localStorage.setItem('uid', data.data.uid);
            localStorage.setItem('token', data.data.token);
            localStorage.setItem('psnId', data.data.psnId);
            localStorage.setItem('uname', data.data.uname);
            this.$router.push('/home');
          } else if (data.code == ErrorVerifyCode){
            this.$message.error("输入的验证码不正确");
          } else {
            this.$message.error("无法验证，请核实数据");
          }
      }catch(e){
        console.error("错误信息：", e);
        this.$message.error("无法登录系统");
      }
    },

    testMobile() {
      this.mobile = this.mobile.trim();
      if (this.mobile == "") {
        this.$message.error("手机号不能为空");
        return false;
      }
      if (this.mobile.length != 11) {
        this.$message.error("手机号长度不正确");
        return false;
      }
      const reg = /^1[0-9]{10}$/;
      if (!reg.test(this.mobile)) {
        this.$message.error("手机号格式不正确");
        return false;
      }
      return true;
    },

    testPassword() {
      this.password = this.password.trim();
      if (this.password == "") {
        this.$message.error("密码不能为空");
        return false;
      }
      return true;
    },

    testCode() {
      this.verifyCode = this.verifyCode.trim();
      if (this.verifyCode == "") {
        this.$message.error("验证码不能为空");
        return false;
      }
      if (this.verifyCode.length != 4) {
        this.$message.error("验证码长度不正确");
        return false;
      }
      return true;
    },

    testAgreement() {
      if (!this.agree) {
        this.$message.error("请首先选择同意《服务协议》");
        return false;
      }
      return true;
    },

    goHome(){
      window.location = "/";
    },
  },
}
</script>

<style scoped>
.control-menu{
  border-right: none;
  margin:15px;
  background-color:#1E2128;
}
.control-menu-item {
  color: white!important;
  height:40px;
  line-height:40px;
  margin: 2px 0;
  padding: 0px;
}
.control-menu-item:hover,
.control-menu-item:active,
.control-menu-item.is-active {
  background-color: #383b43 !important;
  color: #d15a5c !important;
  border-radius: 10px;
}
.control-menu-item:hover,
.control-menu-item:active,
.control-menu-item.is-active {
  background-color: #383b43 !important;
  color: #d15a5c !important;
  border-radius: 10px;
}
.close-menu {
  line-height: 40px;
  color:white;
  font-size:14px;
  cursor: pointer;
}
.close-menu:hover {
  color: #d15a5c !important;
}
.login-tab /deep/ .el-tabs__item {
  padding: 0 30px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(0,0,0,.65);
  line-height: 24px;
}
.login-tab /deep/ .el-tabs__item.is-active {
  color: #e63740;
}
.login-tab /deep/ .el-tabs__item:hover {
  color: #e63740;
}
.login-tab /deep/ .el-tabs__active-bar {
  background: #e63740;
}
</style>